export default "__VITE_ASSET__o$FvzzJa__"